/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-children-prop */
import React from 'react';
import { IconButton } from '@chakra-ui/react';
// import { AiOutlineArrowLeft } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { ArrowCircleLeft } from 'phosphor-react';

export const ReturnButton = ({ previousPage, ...props }: any) => {
  const navigate = useNavigate();
  return (
    <IconButton
      // color={useColorModeValue('text.light.redInterm', 'text.dark.redInterm')}
      variant="ghost"
      borderRadius="full"
      _hover={{ opacity: 0.6 }}
      onClick={() => navigate(`/${previousPage}`)}
      icon={<ArrowCircleLeft size={35} />}
      mr="15px"
      {...props}
    />
  );
};
